module.exports = __webpack_public_path__ + "img/success-sign.2dc40d10.svg";